import React from 'react';
import classNames from 'classnames';
import Icon from '../../../icon';
import Heading from '../../../heading';

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
const StepMarker = ({
  label = '',
  active,
  passed,
  completed,
  invalid,
  disabled,
  className = '',
  children,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onClick = null,
}) => {
  const isInteractive = onClick;
  const classes = classNames('ws-ui-step-line-marker', className, {
    'ws-ui-step-line-marker--interactive': isInteractive,
    'ws-ui-step-line-marker--active': active,
    'ws-ui-step-line-marker--passed': passed,
    'ws-ui-step-line-marker--completed': completed,
    'ws-ui-step-line-marker--invalid': invalid,
    'ws-ui-step-line-marker--disabled': disabled,
  });

  const interactiveProps = {
    role: 'button',
    'aria-label': label,
    tabIndex: '0',
    onClick,
  };

  return (
    // @ts-ignore TS(2322): Type '{ children: Element; role: string; 'aria-lab... Remove this comment to see the full error message
    <div className={classes} {...(isInteractive && interactiveProps)}>
      {completed ? (
        <Icon glyph="check" type="white" />
      ) : (
        <Heading type="heading-6" {...(disabled && { appearance: 'low-emphasis' })}>
          {children}
        </Heading>
      )}
    </div>
  );
};

export default StepMarker;
